import { useQuery } from "react-query";
import * as ajaxEndPoint from "../api/ajax-endpoints";
import { getData } from "../newApis/apiMethods";

type TQuery = {
  Page: number;
  PageSize: number;
  CustomerId: number | null;
  AggregatorId: number;
};

const getThirdPartyLoanHistory = async ({
  Page,
  CustomerId,
  PageSize,
  AggregatorId,
}: TQuery) => {
  const data = await getData(
    `${ajaxEndPoint.GET_THIRD_PARTY_LOAN_HISTORY}?Page=${Page}&PageSize=${PageSize}&CustomerId=${CustomerId}&AggregatorId=${AggregatorId}`,
  );
  return data;
};

export default function useGetThirdPartyLoanHistory({
  Page,
  CustomerId,
  PageSize,
  AggregatorId,
}: TQuery) {
  return useQuery(
    [{ Page, CustomerId, PageSize, AggregatorId }, "getThirdPartyLoanHistory"],
    getThirdPartyLoanHistory,
    {
      enabled: !!CustomerId,
    },
  );
}
